import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/pages/HomePage.vue';
import LoginPage from '@/pages/auth/LoginPage.vue';
import RegistrationPage from '@/pages/auth/RegistrationPage.vue';
import DashboardPage from '@/pages/DashboardPage.vue';
import UserProfilePage from '@/pages/user/UserProfilePage.vue';
import NotFoundPage from '@/pages/common/NotFoundPage.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import authService from '@/services/authService';

const routes = [
    {
        path: '/',
        component: DefaultLayout,
        children: [
            { path: '', name: 'HomePage', component: HomePage },
            { path: '/dashboard', name: 'DashboardPage', component: DashboardPage, meta: { requiresAuth: true } },
            { path: '/profile', name: 'UserProfilePage', component: UserProfilePage, meta: { requiresAuth: true } },
        ],
    },
    {
        path: '/login',
        component: AuthLayout,
        children: [
            { path: '', name: 'LoginPage', component: LoginPage },
        ],
    },
    {
        path: '/register',
        component: AuthLayout,
        children: [
            { path: '', name: 'RegistrationPage', component: RegistrationPage },
        ],
    },
    { path: '/:pathMatch(.*)*', name: 'NotFoundPage', component: NotFoundPage },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Navigation guard to protect routes that require authentication
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !authService.isAuthenticated()) {
        next({ name: 'LoginPage' });
    } else {
        next();
    }
});

export default router;
